import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service3 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (
        <div className="about-events-container">
            {/* First table for images and content */}

            <div className="about-events-images">
                             <img src="/images/special4.webp" />
                             <img src="/images/soecial2.webp" />
                             <img src="/images/special3.webp"  />
                             <img src="/images/special1.webp"  />
                           </div>

                            <div className="about-events-content">
                                 <h2 className="about-header-service">Special Event Celebrations</h2>
                                 <p className="about-events-description">
                                <p>At Cocoloco, we believe every celebration deserves to be unforgettable, and that’s why we go above and beyond to make your special events extraordinary. Whether it's a <strong>lively birthday bash, a charming bridal shower, Anniversary, Co-Operate Events or any other gathering close to your heart,</strong> our garden venue offers an ideal blend of elegance and fun. The expansive, lush outdoor space is designed to host events of all sizes, from intimate gatherings to large-scale celebrations, surrounded by nature’s beauty.</p>
                                <p>At Cocoloco Garden, it’s not just a party, it’s an experience where memories are made, laughter is shared, and moments are cherished forever. Let us help you create the perfect atmosphere to celebrate life’s milestones, making your event as vibrant and unforgettable as our surroundings.</p>
                                </p>

                               <button className="service-button" onClick={handleNavigate}>
                                                                                 Click Here For See More Gallery ..
                                                                             </button>
                       </div>

                                </div>


    );
};

export default Service3;
